import platform from 'utils/platform';
import {
  FEATURE_BIOMETRIC_LOGIN,
  FEATURE_BIOMETRIC_SETUP,
  FEATURE_PUSH_NOTIFICATIONS,
  FEATURE_APP_UPDATE,
  FEATURE_FINSUS,
  FEATURE_REGISTRATION,
  FEATURE_REGISTRATION_NEW_CLIENT,
} from 'constants/featureGates';

const GATE_RULES = {
  [FEATURE_BIOMETRIC_LOGIN]: () => platform.hasBiometrics,
  [FEATURE_BIOMETRIC_SETUP]: () => platform.hasBiometrics,
  [FEATURE_PUSH_NOTIFICATIONS]: () => platform.isNativeApp,
  [FEATURE_APP_UPDATE]: () => platform.isNativeApp,
  [FEATURE_FINSUS]: () => platform.isNativeApp,
  // Registro (vincular cuenta de cliente existente): todas las plataformas,
  // incluido desktop (WEB_MLS-608).
  [FEATURE_REGISTRATION]: () => true,
  // Alta de cliente nuevo + KYC (IDMission) + huella + "Terminar más tarde":
  // SOLO app nativa. En cualquier navegador (móvil o desktop) el flujo se limita
  // a login + vinculación de cliente existente.
  [FEATURE_REGISTRATION_NEW_CLIENT]: () => platform.isNativeApp,
};

const useFeatureGate = (key) => GATE_RULES[key]?.() ?? true;

export default useFeatureGate;
